import { useNavigate } from 'react-router-dom';

import { Button } from '@mui/material';
import { Routes } from 'common/constants/routes';


export type ImportFooterButtonsProps = {
    handleOnClickImport: () => void;
    disableImportButton: boolean;
}

export const ImportFooterButtons = ({ handleOnClickImport, disableImportButton }: ImportFooterButtonsProps) => {
    const navigate = useNavigate();

    const handleClickCancel = () => {
        navigate(`/${Routes.Admin}`);
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button
                variant={'contained'}
                sx={{ marginRight: '1rem' }}
                onClick={handleOnClickImport}
                disabled={disableImportButton}
                data-testid='import'
            >
Import
            </Button>
            <Button
                variant={'outlined'}
                onClick={handleClickCancel}
            >
Cancel
            </Button>
        </div>
    );
};
